module.exports = __webpack_public_path__ + "img/pouzzolane.ab5a3fca.jpg";